var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineChatCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H28V24H13.17L12 25.17V12ZM12 10C10.9 10 10.01 10.9 10.01 12L10 30L14 26H28C29.1 26 30 25.1 30 24V12C30 10.9 29.1 10 28 10H12ZM14 20H22V22H14V20ZM14 17H26V19H14V17ZM14 14H26V16H14V14Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineChatCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-chat_circle-40px.302e8ceb4cd95449bb93831b3a8d842b.svg";
export { ForwardRef as ReactComponent };